import { Button } from '@hud/web-components/Button/Button';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import { themeColor } from '@hud/web-components/theme/colors';
import { TREND_VARIANTS } from '@hud/web-components/Trend/Trend';
import styled from 'styled-components';

export const CellIcon = styled(HudIcon)`
  vertical-align: middle;
  position: relative;
  top: -1px;
  color: ${themeColor('textTertiary')};
  margin-right: 4px;
`;

export const TrendLabel = styled(TREND_VARIANTS['neutral'])`
  margin-left: 6px;
`;

export const StyledMoreItemsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 10px;
`;

export const StyledMoreItemButton = styled(Button).attrs({
  variant: 'outlined',
})`
  display: flex;
  height: 22px;
  padding: 0px 5px 2px 5px;
  align-items: center;
  gap: 2px;
`;
